import users from '../../services/users'
export const checkCode = async ({commit, state}, code) => {
	let dataCode = state.codes.find(c => c.code == code)

	if(!dataCode) {
		return Promise.reject({message: 'Código invalido'})
	}
	let user = JSON.parse(localStorage.getItem('auth'))
	let unlocks = user.unlocks || []
	let newUnlocks = dataCode.activities.filter(a => !unlocks.includes(a))
	user.unlocks = unlocks.concat(newUnlocks)
	let data = await users.setUnlocks({code: user.code, unlocks: user.unlocks})
	commit('auth/setAuthUser', user, { root: true })
	return Promise.resolve({data: dataCode})
}